import { useState, useEffect } from 'react';
import fontcolor from './image/font-color.svg';
// import backcolor from './image/backcolor.png';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import * as EditorTypeAll from '../tinymce';
import TextRemoveIcon from '@/assets/icons/editor-text-remove.svg?react';
import TextCheckIcon from '@/assets/icons/editor-text-check.svg?react';
import {PaintBucket as BackColorIcon } from 'lucide-react';
interface Props {
  editorInstance: EditorTypeAll.Editor;
  type?: 'fontcolor' | 'backcolor' | string;
}

const defaultColors = [
  {
    value: 'rgba(0, 0, 0, 1)',
  },
  {
    value: 'rgba(244, 1, 7, 1)',
  },
  {
    value: 'rgba(247, 153, 6, 1)',
  },
  {
    value: 'rgba(254, 255, 4, 1)',
  },
  {
    value: 'rgba(152, 250, 28, 1)',
  },
  {
    value: 'rgba(109, 222, 255, 1)',
  },
  {
    value: 'rgba(64, 62, 214, 1)',
  },
  {
    value: 'rgba(237, 64, 253, 1)',
  },
  {
    value: 'rgba(233, 233, 233, 1)',
  },
  {
    value: 'rgba(123, 123, 123, 1)',
  },
  {
    value: 'rgba(250, 200, 184, 1)',
  },
  {
    value: 'rgba(252, 225, 178, 1)',
  },
  {
    value: 'rgba(253, 242, 204, 1)',
  },
  {
    value: 'rgba(217, 234, 211, 1)',
  },
  {
    value: 'rgba(224, 248, 255, 1)',
  },
  {
    value: 'rgba(207, 199, 244, 1)',
  },
  {
    value: 'rgba(253, 228, 255, 1)',
  },
  {
    value: 'rgba(217, 217, 217, 1)',
  },
  {
    value: 'rgba(92, 92, 92, 1)',
  },
  {
    value: 'rgba(233, 152, 154, 1)',
  },
  {
    value: 'rgba(249, 184, 77, 1)',
  },
  {
    value: 'rgba(252, 229, 154, 1)',
  },
  {
    value: 'rgba(172, 220, 126, 1)',
  },
  {
    value: 'rgba(133, 213, 229, 1)',
  },
  {
    value: 'rgba(140, 123, 233, 1)',
  },
  {
    value: 'rgba(238, 148, 247, 1)',
  },
  {
    value: 'rgba(196, 196, 196, 1)',
  },
  {
    value: 'rgba(51, 51, 51, 1)',
  },
  {
    value: 'rgba(224, 102, 102, 1)',
  },
  {
    value: 'rgba(247, 141, 0, 1)',
  },
  {
    value: 'rgba(251, 218, 104, 1)',
  },
  {
    value: 'rgba(135, 193, 31, 1)',
  },
  {
    value: 'rgba(76, 194, 238, 1)',
  },
  {
    value: 'rgba(63, 73, 186, 1)',
  },
  {
    value: 'rgba(208, 65, 225, 1)',
  },
  {
    value: 'rgba(157, 158, 158, 1)',
  },
  {
    value: 'rgba(38, 38, 38, 1)',
  },
  {
    value: 'rgba(204, 0, 0, 1)',
  },
  {
    value: 'rgba(231, 82, 0, 1)',
  },
  {
    value: 'rgba(249, 183, 3, 1)',
  },
  {
    value: 'rgba(103, 143, 1, 1)',
  },
  {
    value: 'rgba(49, 137, 251, 1)',
  },
  {
    value: 'rgba(39, 65, 178, 1)',
  },
  {
    value: 'rgba(164, 26, 212, 1)',
  },
];

function convertToRgba(color: string) {
  if (color.startsWith('#')) {
    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, 1)`;
  } else if (color.startsWith('rgba')) {
    return color;
  } else if (color.startsWith('rgb')) {
    const values = color.match(/\d+/g);
    return values ? `rgba(${values[0]}, ${values[1]}, ${values[2]}, 1)` : '';
  } else {
    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);
    const style = window.getComputedStyle(div);
    const rgb = style.color;
    document.body.removeChild(div);
    return convertToRgba(rgb);
  }
}

const Fontsizeselect = ({ editorInstance, type }: Props) => {
  const [visible, setVisible] = useState(false);
  const [selectColor, setSelectColor] = useState('');
  const [colorList] = useState(defaultColors);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', (event: { element: Element }) => {
        let focusColor = editorInstance.dom.getStyle(
          event.element,
          type === 'fontcolor' ? 'color' : 'background-color',
          true
        );
        if (focusColor) {
          focusColor = convertToRgba(focusColor);
        }
        setSelectColor(focusColor);
      });
    }
  }, [editorInstance, type]);

  const selectColorCl = (color: { value: string }) => {
    const value = color.value;
    if (!editorInstance) return;
    setSelectColor(value);
    if (value === 'remove') {
      editorInstance.execCommand('mceRemoveTextcolor', type === 'fontcolor' ? 'forecolor' : 'hilitecolor');
    } else {
      editorInstance.execCommand('mceApplyTextcolor', type === 'fontcolor' ? 'forecolor' : 'hilitecolor', value);
    }
    setVisible(false);
  };

  return (
    <Popover open={visible} onOpenChange={setVisible} modal={true}>
      <PopoverTrigger asChild>
        <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]">
          <div>
            {type === 'fontcolor' ? (
              <img width="18px" height="18px" src={fontcolor} />
            ) : (
              <BackColorIcon strokeWidth={1.5} size={18} />
            )}
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-auto" side="top" align="start" sideOffset={5} style={{ zIndex: 9999 }}>
        <div className="shadow-lg rounded-sm border border-gray-300">
          <div className="flex w-64 flex-wrap justify-between text-xs p-3">
            <div
              title="移除颜色"
              onClick={() => {
                selectColorCl({ value: 'remove' });
              }}
              className="flex items-center justify-center h-6 w-6 rounded cursor-pointer hover:border hover:border-blue-600 mb-5 transition-all duration-150"
            >
              <TextRemoveIcon />
            </div>
            {colorList.map(color => (
              <div
                className="flex items-center justify-center h-6 w-6 rounded cursor-pointer hover:border hover:border-blue-600 mb-0.5 transition-all duration-150"
                style={{ backgroundColor: color.value }}
                onClick={() => {
                  selectColorCl(color);
                }}
              >
                {selectColor === color.value && <TextCheckIcon />}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Fontsizeselect;
